"use strict";
import {on, findIn} from "@elements/dom-utils";
import TerracePlanner from "./index";

export function init() {
    let loadInput = findIn('.js-planner__load-terrace-input', TerracePlanner.element);
    let loadButton = findIn('.js-planner__load-terrace-submit', TerracePlanner.element);

    if(!TerracePlanner.loggedIn) {
        if (loadButton) {
            on('click', (evt) => {
                evt.preventDefault();

                TerracePlanner.shareCode = loadInput.value;
                location.href = window.location.protocol + '//' + window.location.hostname + location.pathname + '?shareCode=' + TerracePlanner.shareCode;
            }, loadButton)
        }
    }
}